import React, { useEffect, useState } from 'react';

export const ResultList = props => {
  const { controller, resultTemplatesManager } = props;
  const [state, setState] = useState(controller.state);
  const [isLoading, setIsLoading] = useState(true);
  const additionalClasses = props.additionalClasses || '';

  const { dataset } = document.getElementsByClassName(
    'coveo-search-results__main-wrapper'
  )[0];

  const labels = JSON.parse(dataset.localization);

  useEffect(() => {
    const subscription = controller.subscribe(() => {
      setState(controller.state);
      setIsLoading(false);
    });
  }, [controller]);

  if (isLoading && state.results.length === 0) {
    return (
      <div
        className="coveo-search-results__results rtf"
        dangerouslySetInnerHTML={{ __html: labels.loadingMessage }}
      />
    );
  }


  if (state.firstSearchExecuted) {
    if (!state.results.length) {
      return (
        <div
          className="coveo-search-results__results rtf coveo-search-results__results--no-results"
          dangerouslySetInnerHTML={{ __html: labels.noResultsMessage }}
        />
      );
    }
  }

  return (
    <div className="coveo-search-results__results">
      <ul className={`coveo-search-results__results-list ${additionalClasses}`}>
        {state.results.map(result => {
          const template = resultTemplatesManager.selectTemplate(result);

          if (!template)
            throw new Error(`No result template provided for ${result.title}.`);

          return template(result);
        })}
      </ul>
    </div>
  );
};
